module.exports = __webpack_public_path__ + "static/img/beijing.fbddeb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/city/beijing.jpg
// module id = KzhZ
// module chunks = 1